import React from 'react';

const NavItem = ({ icon, label, active, onClick }) => (
  <button
    onClick={onClick}
    className={`w-full flex items-center gap-3 px-3 py-2 transition-all rounded-lg ${
      active
        ? 'text-[#041627] font-semibold bg-white shadow-sm'
        : 'text-slate-500 hover:text-[#041627] hover:bg-slate-100'
    }`}
  >
    {icon}
    <span className="text-sm">{label}</span>
  </button>
);

export default NavItem;